import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { accessSteps, downloadUrl, productImage, supportEmail } from '../data/accessSteps';
export function ThankYouCard() {
  return <motion.article initial={{
    opacity: 0,
    y: 16,
    scale: 0.98
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className="w-full max-w-[640px] rounded-[20px] border border-white/[0.08] bg-ink-700 bg-[linear-gradient(145deg,#141d2b,#0f1923)] px-6 py-10 text-center shadow-card sm:px-10 sm:py-12" data-id="element-2" data-mp="3360mou3n5r2e">
      <div className="mx-auto mb-6 flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[linear-gradient(135deg,#c8f53b,#a8d520)] shadow-badge" data-id="element-3" data-mp="3lz4jupg2im1r">
        <CheckIcon className="h-9 w-9 text-ink-900" strokeWidth={3.5} aria-hidden="true" data-id="element-4" data-mp="3vw98cvxdytlq" />
      </div>

      <h1 className="text-[28px] font-black leading-[1.2] tracking-tight text-white sm:text-[30px]" data-id="element-5" data-mp="3szymlu8axcr">
        Merci pour votre achat<span className="text-lime-400" data-id="element-6" data-mp="28iodebnltp1i"> !</span>
      </h1>

      <p className="mx-auto mt-3 max-w-[460px] text-[15px] leading-[1.7] text-white/60" data-id="element-7" data-mp="23i0nxuf0xg9e">
        Votre accès à Football Prêt : Système 365 est prêt. Enregistrez cette
        page ou suivez les étapes ci-dessous pour ne rien manquer.
      </p>

      <img src={productImage} alt="Les 6 volumes de Football Prêt : Système 365 présentés sur ordinateur portable et tablette" className="mx-auto mt-8 w-full rounded-xl border border-white/[0.06]" width={1280} height={853} data-id="element-8" data-mp="1tm77w123j4mv" />

      <section className="mt-8 rounded-xl border border-white/[0.06] bg-white/[0.03] px-6 py-5 text-left" data-id="element-9" data-mp="2hgqlfb5r9hya">
        <h2 className="mb-3.5 text-[11px] font-bold uppercase tracking-[2px] text-lime-400" data-id="element-10" data-mp="2cifcr3r75dhn">
          Comment accéder à votre contenu
        </h2>
        <ol className="space-y-3" data-id="element-11" data-mp="357w2turcgiap">
          {accessSteps.map((step, index) => <li key={step.text} className="flex gap-3" data-id="element-12" data-mp="13a3rc027ki45" data-mpi={index}>
              <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime-400/10 text-[12px] font-bold text-lime-400" data-id="element-13" data-mp="13bex25f7rzxw">
                {index + 1}
              </span>
              <p className="text-sm leading-[1.65] text-white/75" data-id="element-14" data-mp="yiu5zbnp00y2">
                {step.emphasis && <strong className="font-bold text-white" data-id="element-15" data-mp="kjcjj2xvczrv">
                    {step.emphasis}{' '}
                  </strong>}
                {step.text}
              </p>
            </li>)}
        </ol>
      </section>

      <a href={downloadUrl} target="_blank" rel="noopener noreferrer" className="group mt-8 flex w-full items-center justify-center gap-2 rounded-xl bg-[linear-gradient(135deg,#c8f53b,#a8d520)] px-6 py-5 text-[17px] font-black tracking-[0.5px] text-ink-900 shadow-cta transition-transform duration-200 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-lime-400" data-id="element-16" data-mp="anj1j41dse2p">
        Télécharger mon système maintenant
        <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" strokeWidth={3} aria-hidden="true" data-id="element-17" data-mp="80qebzgikjo3" />
      </a>

      <p className="mt-8 border-t border-white/[0.07] pt-6 text-[12.5px] leading-[1.7] text-white/40" data-id="element-18" data-mp="h1esqv9tkm1i">
        Vous n'avez pas reçu l'e-mail ou vous rencontrez un problème d'accès ?
        Écrivez-nous à{' '}
        <a href={`mailto:${supportEmail}`} className="text-lime-400 underline-offset-4 hover:underline" data-id="element-19" data-mp="r0e4wntsmzt9">
          {supportEmail}
        </a>
      </p>
    </motion.article>;
}